import React, { useState, useEffect } from "react";
import "./Home.css";
import BrandSlider from "../components/BrandSlider";
import ContactPopup from "../components/ContactPopup";
import Hero from "../components/Hero";
import StatsPanel from "../components/StatsPanel";
import heroProcessVideo from '../assets/hero-process.mp4';


// Background images
import sustainabilityBg from "../assets/factory-cutting.png";
import productionBg from "../assets/factory-front.png";
import factoryImg from "../assets/factory-front.png";

// Product/facility images
import empoweredWorkforceImg from "../assets/empowered-workforce.png";
import waterEfficiencyImg from "../assets/water-efficiency.png";
import energyEmissionsImg from "../assets/energy-emissions.png";
import chemicalsMaterialsImg from "../assets/chemical-materials.png";

// Product images (update paths as needed)
import infantSetImg from "../assets/pdt-kids-pack.png";
import romper1Img from "../assets/pdt-romper.png";
import sweatshirtImg from "../assets/pdt-sweatshirts1.png";
import graphicTeeImg from "../assets/pdt-graphic-tee1.png";
import womenTunicImg from "../assets/pdt-womens1.png"
import joggerImg from "../assets/pdt-joggers1.png";

import workwearImg from "../assets/pdt-uniform-polos.png";
import frcImg from "../assets/pdt-frc.png";
import medicalScrubsImg from "../assets/pdt-medicalscrubs.png";
import arcSuitImg from "../assets/pdt-arcsuit.png";

import apronImg from "../assets/pdt-apron.jpg";
import tableclothImg from "../assets/pdt-table-cloth.png";
import shirtImg from "../assets/pdt-shirt.png";
import boxerImg from "../assets/pdt-boxer-shorts.jpg";
import laundryBagImg from "../assets/pdt-laundry-bag.jpg";
import totebagImg from "../assets/pdt-totebag.jpg"
import fcushionImg from "../assets/pdt-floor-cushion.jpg";
import bathTowelImg from "../assets/pdt-bath-towels.png";


// Product data with images
const impexProducts = [
  { name: "Infant Set", desc: "Soft cotton infant set", img: infantSetImg },
  { name: "Rompers", desc: "Comfortable and stylish rompers", img: romper1Img },
  { name: "Sweatshirts", desc: "Cozy and warm sweatshirts", img: sweatshirtImg },
  { name: "Graphic Tees", desc: "High Definition Graphic Print Tees", img: graphicTeeImg },
  { name: "Joggers", desc: "Comfortable and stylish joggers", img: joggerImg },
  { name: "Womens Fashion Tunics", desc: "Stylish and comfortable tunics", img: womenTunicImg }
];

const textilesProducts = [
  { name: "Uniform Polos", desc: "Durable industry class polos", img: workwearImg },
  { name: "Shirts & Trousers", desc: "Professional work shirts and trousers", img: shirtImg },
  { name :"Boxer Shorts", desc: "Comfortable and breathable boxer shorts", img: boxerImg},
  { name :"Apron", desc: "Durable and protective aprons for kitchen use", img: apronImg},
  { name :"Table Cloths", desc: "Elegant and durable table cloths", img: tableclothImg},
  { name :"Laundry Bags", desc: "Durable and spacious laundry bags", img: laundryBagImg},
  { name :"Tote Bags", desc: "Stylish and eco-friendly tote bags", img: totebagImg},
  { name :"Floor Cushions", desc: "Comfortable and stylish floor cushions", img: fcushionImg},
  { name :"Bath Towels", desc: "Soft and absorbent bath towels", img: bathTowelImg},
  { name: "FRC Suit", desc: "Flame resistant coverall and sets", img: frcImg },
  { name: "Medical Scrubs", desc: "Professional medical scrubs", img: medicalScrubsImg },
  { name: "Arc Suit", desc: "High visibility arc protection suit", img: arcSuitImg },
];

function AutoCarousel({ products, interval = 2500 }) {
  const [current, setCurrent] = React.useState(0);

  React.useEffect(() => {
    const t = setTimeout(() => {
      setCurrent((p) => (p + 1) % products.length);
    }, interval);
    return () => clearTimeout(t);
  }, [current, products.length, interval]);

  return (
    <div className="product-carousel auto-carousel">
      <div className="product-card hover-reveal" key={current} tabIndex={0}>
        <img
          src={products[current].img}
          alt={products[current].name}
          loading="lazy"
        />
        <div className="product-name">{products[current].name}</div>
        <div className="product-desc">{products[current].desc}</div>
      </div>
    </div>
  );
}




function Home() {
  const [popupOpen, setPopupOpen] = useState(false);

  return (
    <div className="home-container">
      <Hero
        eyebrow="SAI SENA"
        headline="Your Trusted Partner For Apparel Manufacturing"
        body="We take pride in being the preferred choice for brands that value precision, consistency, and innovation. With a strong focus on craftsmanship and attention to detail, we deliver garments and textiles that embody both performance and style. Our commitment to quality and customer satisfaction ensures long-term partnerships built on trust and excellence."
        bgVideo={heroProcessVideo}
      />
      

      {/* About */}
      <section className="about-section main-section">
        <h2>About Us</h2>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: "0 3.5rem" }}>
          <div style={{ maxWidth: 740, minWidth: 320 }}>
            <p>
              <strong>Sai Sena Impex Pvt Ltd</strong> is a trusted global partner delivering high-quality knitted and woven garments, workwear, and home textiles from our advanced facilities. We specialize in custom manufacturing with a firm commitment to sustainability, ethical practices, and international safety standards.
            </p>
            <p>
              Our integrated approach ensures rapid turnaround and consistent excellence across all categories. We build long-term partnerships through reliability, workforce empowerment, and a dedicated focus on textile innovation.
            </p>
          </div>
          <div style={{ minWidth: 260, maxWidth: 340 }}>
            <img
              src={factoryImg}
              alt="Sai Sena Impex Factory"
              style={{
                width: "100%",
                maxWidth: "340px",
                borderRadius: "1.5rem",
                boxShadow: "0 4px 24px 0 #a855f744",
                objectFit: "cover"
              }}
            />
          </div>
        </div>
      </section>
      {/* Target Trackers */}
      <StatsPanel />
      {/* Vision / Mission */}
      <section className="vision-mission-section main-section">
        <h2>Weaving sustainability, empowering women, transforming communities.</h2>
        <div className="vm-grid">
            <div className="vm-item">
           <img src={empoweredWorkforceImg} alt="Empowered Workforce" />
           </div>
          <div className="vm-item">
            <p>
              Every thread tells a story of resilience, every skill uplifts a life, and every step we take is toward a future where women and communities flourish together.
            </p>
          </div>
        </div>
      </section>

      {/* Sustainability */}
      <section className="sustainability-section main-section">
        <div className="section-bg-img" style={{ backgroundImage: `url(${sustainabilityBg})` }} />
        <h2>Building Sustainability for a Greener Future</h2>
        <div className="sustainability-grid">
          
          <div className="sustain-item">
            <img src={waterEfficiencyImg} alt="Water Efficiency" />
            <h3>Water Efficiency</h3>
          </div>
          <div className="sustain-item">
            <img src={energyEmissionsImg} alt="Energy and Emissions" />
            <h3>Energy & Emissions</h3>
          </div>
          <div className="sustain-item">
            <img src={chemicalsMaterialsImg} alt="Chemicals and Materials" />
            <h3>Chemicals & Materials</h3>
          </div>
        </div>
      </section>

      {/* Production */}
      <section className="production-section main-section">
        <div className="section-bg-img" style={{ backgroundImage: `url(${productionBg})` }} />
        <div className="division-grid">
          <div className="division-item">
            <div className="division-content" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", padding: "0rem 3.5rem" }}>
              <h2>Sai Sena Impex</h2>
              <p>Excellence in knitted garment production is achieved through precision craftsmanship, premium materials, and continuous innovation, creating durable, comfortable, and stylish apparel that consistently meets global market demands while delivering unmatched quality, reliability, and long-lasting value.</p>
              <AutoCarousel products={impexProducts} />
            </div>
          </div>
          <div className="division-item">
            <div className="division-content" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", padding: "0rem 3.5rem" }}>
              <h2>Sai Textiles</h2>
              <p>Advanced textile solutions specializing in workwear, medical scrubs, FRC suits, woven garments, and premium home textiles.
Every product prioritizes quality, innovation, and global safety standards to ensure durability and comfort across industrial and domestic sectors.</p>              
              <AutoCarousel products={textilesProducts} />
            </div>
          </div>
        </div>
      </section>

      

      {/* Brands - Responsive, auto-fit, no overflow */}
            {/* Brands - Auto Scrolling Carousel */}
      <section className="brands-section main-section">
        <h2>Brands Who Trust Us</h2>
          {/*<div className="brands-track">
            {[sinsayLogo, sistersLogo, guessLogo, urbanMonkeyLogo, minimodeLogo,
              // Duplicate logos for seamless infinite scroll
              sinsayLogo, sistersLogo, guessLogo, urbanMonkeyLogo, minimodeLogo
            ].map((logo, idx) => (
              <div key={idx} className="brand-logo-wrapper">
                <img src={logo} alt={`Brand logo ${idx + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section> */}
        <BrandSlider />
      </section>

      {/* Contact CTA */}
      <section className="contact-cta-section">
        <h2>Ready to Partner With Us?</h2>
        <p>
          Connect with us today for partnership opportunities and production requirements.<br />
          Let's create something extraordinary together.
        </p>
        <button className="btn-contact" onClick={() => setPopupOpen(true)}>
          Get In Touch
        </button>
      </section>
      <ContactPopup open={popupOpen} onClose={() => setPopupOpen(false)} />
    </div>
  );
}

export default Home;

